import React from 'react';
import { User } from 'firebase/auth';
import { UserProfile } from '@/lib/auth/types';
import { formatDate } from '@/lib/utils/date';
import { SubscriptionBadge } from './SubscriptionBadge';

interface ProfileHeaderProps {
  user: User;
  profile: UserProfile | null;
}

export function ProfileHeader({ user, profile }: ProfileHeaderProps) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-6">
          <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center">
            <span className="text-2xl font-medium text-gray-600">
              {(profile?.displayName || user.email || '?')[0].toUpperCase()}
            </span>
          </div>
          <div>
            <div className="flex items-center gap-4">
              <h1 className="text-2xl font-bold">
                {profile?.displayName || user.email}
              </h1>
              <SubscriptionBadge subscription={profile?.subscription} />
            </div>
            <div className="text-sm text-gray-500 space-y-1 mt-2">
              <p>Member since: {formatDate(profile?.createdAt)}</p>
              <p>Last login: {formatDate(profile?.lastLoginAt)}</p>
              <p>Current plan: {profile?.subscription?.tier || 'FREE'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
